<template>
  <TresGroup>
    <primitive
      ref="scene1Ref"
      :object="scene1"
      :scale="[1.5, 1.5, 1.5]"
      :rotation="[Math.PI / 2, 0, 0]"
      :position="[(props.row + 1) % 2 ? 24 : 12, 0, -0.7]"
    />
    <primitive
      ref="scene2Ref"
      :object="scene2"
      :scale="[1.5, 1.5, 1.5]"
      :rotation="[Math.PI / 2, 0, 0]"
      :position="[48, 0, -0.7]"
    />
  </TresGroup>
</template>

<script setup lang="ts">
import { MeshPhysicalMaterial } from 'three'
import { gsap } from 'gsap'

interface Props {
  row: number
  scene: Scene
}

const props = withDefaults(defineProps<Props>(), {
  row: 0,
  scene: null
})

const workAnimation = useState('workAnimation')

const scene1 = props.scene.clone()
const scene2 = props.scene.clone()

const scene1Ref = ref<THREE.Object3D | null>(null)
const scene2Ref = ref<THREE.Object3D | null>(null)

const frameMaterial = new MeshPhysicalMaterial({
  color: 0xffffff,
  metalness: 0.8,
  roughness: 0.2
})

scene1.traverse((child) => {
  if (child.isMesh) {
    if (child.name === 'Frame') {
      child.material = frameMaterial
    }
  }
})

scene2.traverse((child) => {
  if (child.isMesh) {
    if (child.name === 'Frame') {
      child.material = frameMaterial
    }
  }
})
watch(
  () => workAnimation.value,
  (value) => {
    if (value) {
      startWorkItemAnimation()
    }
  }
)
function startWorkItemAnimation() {
  scene1Ref.value!.position.z = -10
  scene2Ref.value!.position.z = -10
  if (workAnimation.value) {
    gsap.to(scene1Ref.value!.position, {
      z: 0,
      duration: 3.0,
      ease: 'power3.out',
      delay: props.delay
    })
    gsap.to(scene2Ref.value!.position, {
      z: 0,
      duration: 3.0,
      ease: 'power3.out',
      delay: props.delay
    })
  }
}
onMounted(() => {
  startWorkItemAnimation()
})
</script>
